import { CanActivateFn, Router } from "@angular/router";
import { inject } from "@angular/core";
import { SessionService } from "@common/services/session.service";
import { ROUTES_MAIN } from "@common/enums/routes-main.enum";
import { ROUTES_AUTH } from "@modules/auth/enums/routes-auth.enum";

export const sessionExistGuard: CanActivateFn = () => {
  const sessionService = inject(SessionService);
  const router = inject(Router);

  if(sessionService.value){
    return true;
  }

  router.navigate([ROUTES_MAIN.AUTH, ROUTES_AUTH.LOGIN]);
  return false;
}

export const sessionNotExistGuard: CanActivateFn = () => {
    const sessionService = inject(SessionService);
    const router = inject(Router);
  
    if(!sessionService.value){
      return true;
    }
  
    router.navigate([ROUTES_MAIN.DASHBOARD]);
    return false;
}